module.exports = __webpack_public_path__ + "img/email_setting.76a1d698.png";